import { useState, useEffect } from 'react'

const usePageVisibility = () => {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    // This check ensures code within this block runs only in the browser b/c using useAppVersion check in page layout causes a server error to be thrown
    if (typeof document === 'undefined') {
      return
    }

    setIsVisible(document.visibilityState === 'visible')

    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === 'visible')
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return isVisible
}

export default usePageVisibility
